import React, {Component} from 'react'
import PropTypes from 'prop-types'

var styles = {
  content: {
    margin: '0 auto',
    padding: '25vh 0 10vh',
    fontSize: '25px',
    color: '#26344B',
    width: '350px',
    textAlign: 'center'
  }
}

function Loading (props) {
  return (
    <div style={styles.content}>
      <div style={{display: 'block'}}>
        <i className="fa fa-camera-retro fa-spin fa-3x fa-fw" style={{lineHeight: 'normal'}}></i>
        <span className="sr-only">Loading...</span>
      </div>
    </div>)
}

export default Loading
